import { DeltaInsertOp } from '../renderer/DeltaInsertOp';
import { OpToHtmlConverter } from '../renderer/OpToHtmlConverter';
import { QuillDeltaToHtmlConverter } from '../renderer/QuillDeltaToHtmlConverter';
import { convertFontFormat, styleToCSS } from './format';
import { InlineReference } from './InlineReference';
import { InlineValue } from './InlineValue';

export interface QuillDelta {
  ops: DeltaInsertOp[];
}

export function convertDeltaToHTML(quillDelta: string, styleObj: any, dataRow: any, sizeFactor: number = 1, content?: any, customStyle: any = {}) {
  const renderInlineValue = (customOp: any) => {
    try {
      if (customOp.insert.type === 'inlineValue') {
        const opToHtml = new OpToHtmlConverter(customOp, { inlineStyles: true, sizeFactor });
        // const classes = opToHtml.getCssClasses();
        // const styles = opToHtml.getCssStyles();
        const html = opToHtml.getHtml();

        const inlineValue = InlineValue.create(customOp);
        let inlineStr = inlineValue.resolveFields(dataRow, '', content);
        inlineStr = inlineStr.replace(/-/g, '&#8209;');

        return html.replace('[object Object]', inlineStr);
      } else if (customOp.insert.type === 'inlineReference') {
        const opToHtml = new OpToHtmlConverter(customOp, { inlineStyles: true, sizeFactor });
        // const classes = opToHtml.getCssClasses();
        // const styles = opToHtml.getCssStyles();
        const html = opToHtml.getHtml();

        const inlineValue = InlineReference.create(customOp);
        let inlineStr = inlineValue.resolveFieldsReference(dataRow, '', content);
        inlineStr = inlineStr.replace(/-/g, '&#8209;');

        return html.replace('[object Object]', inlineStr);
      } else {
        return 'Unmanaged custom blot!';
      }
    } catch (error) {
      console.log('[QuillDeltaToHtmlConverter] error:', error);
      return 'Error in custom blot!';
    }
  };

  const htmlStyle = convertFontFormat(styleObj);
  delete htmlStyle.color;

  const cssStyle = styleToCSS({ ...htmlStyle, ...customStyle });

  let delta: QuillDelta = { ops: [] };
  if (typeof quillDelta === 'string') {
    delta = JSON.parse(quillDelta);
  }

  const converter = new QuillDeltaToHtmlConverter(delta.ops, { inlineStyles: true, sizeFactor });
  converter.renderCustomWith(renderInlineValue);

  const htmlStr = `<div style="${cssStyle}">${converter.convert()}</div>`;
  return htmlStr;
}
